module.exports = __webpack_public_path__ + "img/3.c9bc88ba.png";